const Strings = {
    errors: {
        SYNTAX_F: 'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
        SYNTAX_C: `Unexpected token '<', "<!DOCTYPE "... is not valid JSON`,
        POPUP: "Cannot read properties of null (reading 'focus')",
        NETWORK_F: 'NetworkError when attempting to fetch resource.',
        NETWORK_C: 'Failed to fetch'
    },
    localStorage: {
        AST_SVG: 'AST_SVG_STRING',
        CFG_SVG: 'CFG_SVG_STRING',
        GAS_OPT_FILES: 'GAS_OPT_FILES',
        SSA_FILES: 'SSA_FILES',
        OGR_FILES: 'OGR_FILES'
    },
    config: {
        DEMO_CODE: '// Enter your code here.... \n',
        VERSION: '1.2'
    },
    colors: {
        BG_HIGHLIGHT: '#B5D2FE'
    }
};

export default Strings;
